import { Nav } from "react-bootstrap";

import { UserAuth } from "../Context";

import { ChannelList } from "stream-chat-react";
import ChatFilter from "./ChatFilter";
import { getFilters } from "./lib.js/getFilters";
import useChatFilter from "../StatesStore/ChatFilter";
import { useEffect, useState } from "react";
import ChatSearch from "./ChatSearch";

function SideBar({
  chatId,
  loadedFirstTime,
  setLoadedFirstTime,
  setActiveChannel,
}) {
  const { user } = UserAuth();
  // const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  const { chatFilterType } = useChatFilter();

  // useEffect(() => {
  //   const handleResize = () => {
  //     setIsSmallScreen(window.innerWidth < 768);
  //   };

  //   window.addEventListener("resize", handleResize);
  //   return () => window.removeEventListener("resize", handleResize);
  // }, []);

  const sort = [{ pinned_at: -1 }, { last_message_at: -1 }, { updated_at: -1 }];

  const options = {
    state: true,
    presence: true,
    // limit: 10,
  };
  // useEffect(() => {
  //   console.log("loadedFirstTime", loadedFirstTime);
  // }, [loadedFirstTime]);

  const [filters, setFilters] = useState(getFilters(chatFilterType, user));
  useEffect(() => {
    setFilters(getFilters(chatFilterType, user));
  }, [chatFilterType]);

  return (
    <div className="sideBarWidth pe-0">
      <style jsx>
        {`
          .sideBarWidth {
            -webkit-box-flex: 0;
            -ms-flex: 0 0 auto;
            flex: 0 0 auto;
            width: 23.6vw;
          }
          .str-chat__channel-list {
            width: 23.6vw !important;
          }
          .str-chat__load-more-button__button,
          .str-chat__cta-button {
            width: 21vw !important;
          }
          .str-chat__channel-preview-messenger--last-message {
            width: 18vw !important;
          }
          .str-chat__channel-preview-messenger--name {
            width: 16vw !important;
          }
          .str-chat__channel-preview {
            padding: 0.75rem 20px !important;
          }
          .str-chat__channel-preview__action-buttons {
            margin-right: 10px !important;
          }
        `}
      </style>
      <nav
        className="navbar navbar-expand-md m-0 p-0"
        style={{ borderRight: "1px solid #EDEDED" }}
      >
        <div
          className="offcanvas offcanvas-start"
          tabIndex="-1"
          id="offcanvasSideChatbar"
          role="tablist"
        >
          <div className="offcanvas-header">
            <button
              type="button"
              className="btn-close text-reset ms-auto"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </div>
          <div className="offcanvas-body p-0 pb-2" style={{ height: "93vh" }}>
            <div className="rounded-2 p-0 h-100 w-100">
              <div
                className="chat-list-content h-100"
                style={{
                  overflowY: "auto",
                  overflowX: "hidden",
                }}
              >
                <ChatFilter />
                <ChatSearch setFilters={setFilters} />
                <Nav className="d-flex flex-column nav-pills nav-pills-soft gap-4">
                  <span
                    className="rounded-2"
                    data-bs-dismiss="offcanvas"
                    style={{
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setLoadedFirstTime(false);
                      setActiveChannel(null);
                    }}
                  >
                    <ChannelList
                      filters={filters}
                      sort={sort}
                      options={options}
                      customActiveChannel={loadedFirstTime ? null : chatId}
                    />
                  </span>
                </Nav>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default SideBar;
